<div class="wrapper" [class.wrapper--blured]="isLoading" [class.wrapper--missing]="disableSignature || disableInitials">
  <app-switch-tabs
    [options]="[
      [SignatureFormat.Handwriting, 'signature.text' | translate],
      [SignatureFormat.Draw, 'signature.draw' | translate],
      [SignatureFormat.Image, 'signature.image' | translate],
      [SignatureFormat.Eletronic, 'signature.markup' | translate]
    ]"
    inputWidth="100%"
    [(ngModel)]="format"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="selectPreviewMode($event)"
    [class.d-none]="!format || disableFormat || disableSignature"
  ></app-switch-tabs>

  <div class="appearance__container">
    <div
      class="appearance__wrapper appearance__wrapper--signature forceDefaultColors"
      [class.d-none]="disableSignature"
      [class.dragover]="isDraggingSignature"
      (dragover)="onDragOver($event, 'signature')"
      (dragleave)="onDragLeave($event, 'signature')"
      (drop)="onDrop($event, 'signature')"
    >
      <canvas class="appearance__canvas" [class.off]="!isPadOn" #signatureCanvas></canvas>

      <div class="appearance__line" [class.off]="![SignatureFormat.Handwriting, SignatureFormat.Eletronic].includes(format)" #signatureLine>
        @if (format) {
          <div class="appearance">
            @if (format === SignatureFormat.Handwriting && currentUser) {
              <div class="appearance__handwriting {{ (font || '').toLowerCase() }}">{{ signatureForm.get('user.signature_text').value }}</div>
            }

            @if (format === SignatureFormat.Eletronic) {
              <div class="appearance__electronic">{{ 'signature.electronicallySigned' | translate }}</div>
            }
          </div>
        }
      </div>

      @if (format && format === SignatureFormat.Image) {
        <div class="appearance">
          @if (selectedSignatureImageUrl) {
            <img class="appearance__image" [src]="selectedSignatureImageUrl | safeUrl" alt="" />
          }
        </div>
      }

      <div class="btn__wrapper">
        @if (!format || format === SignatureFormat.Draw) {
          <button type="button" class="btn-S btn-text" (click)="clearSignature()">{{ 'button.clean' | translate }}</button>
        }

        @if (format === SignatureFormat.Image && selectedSignatureImageUrl) {
          <label class="btn-S btn-text icon-start">
            <input type="file" class="d-none" accept="image/png,image/jpg,image/jpeg" (change)="selectSignatureImage($event.target['files'][0]); $any($event.target).value = ''" />
            <i class="far fa-edit"></i>
            {{ 'signature.change' | translate }}
          </label>
        }
      </div>

      <div class="appearance__title">
        <div class="far fa-signature"></div>
        {{ 'signature.signature' | translate }}
      </div>

      <div class="appearance__description" [class]="format === SignatureFormat.Draw ? 'pe-none' : ''">
        @if (format === SignatureFormat.Draw && isEmptySignature() && !isLoading) {
          <span>
            {{ 'signature.drawSignatureHere' | translate }}
          </span>
        }

        @if (format === SignatureFormat.Image && !selectedSignatureImageUrl) {
          <label class="btn-S btn-text icon-start">
            <input type="file" class="d-none" accept="image/png,image/jpg,image/jpeg" (change)="selectSignatureImage($event.target['files'][0]); $any($event.target).value = ''" />
            <i class="far fa-cloud-upload-alt"></i>
            {{ 'signature.selectOrDrag' | translate }}
          </label>
        }
      </div>
    </div>

    <div
      class="appearance__wrapper appearance__wrapper--initials forceDefaultColors"
      [class.d-none]="disableInitials"
      [class.dragover]="isDraggingInitials"
      (dragover)="onDragOver($event, 'initials')"
      (dragleave)="onDragLeave($event, 'initials')"
      (drop)="onDrop($event, 'initials')"
    >
      <canvas class="appearance__canvas" [class.off]="!isPadOn" #initialsCanvas></canvas>

      <div class="appearance__line" [class.off]="![SignatureFormat.Handwriting, SignatureFormat.Eletronic].includes(format)" #initialsLine>
        @if (format) {
          <div class="appearance">
            @if (currentUser && [SignatureFormat.Handwriting, SignatureFormat.Eletronic].includes(format)) {
              <div class="appearance__handwriting {{ (font || '').toLowerCase() }}">
                {{ signatureForm.get('user.initials_text').value }}
              </div>
            }
          </div>
        }
      </div>

      @if (format && format === SignatureFormat.Image) {
        <div class="appearance">
          @if (selectedInitialsImageUrl) {
            <img class="appearance__image" [src]="selectedInitialsImageUrl | safeUrl" alt="" />
          }
        </div>
      }

      <div class="btn__wrapper">
        @if (!format || format === SignatureFormat.Draw) {
          <button type="button" class="btn-S btn-text" (click)="clearInitials()">{{ 'button.clean' | translate }}</button>
        }

        @if (format === SignatureFormat.Image && selectedInitialsImageUrl) {
          <label class="btn-S btn-text icon-start">
            <input type="file" class="d-none" accept="image/png,image/jpg,image/jpeg" (change)="selectInitialsImage($event.target['files'][0]); $any($event.target).value = ''" />
            <i class="far fa-edit"></i>
            {{ 'signature.change' | translate }}
          </label>
        }
      </div>

      <div class="appearance__title">
        <div class="far fa-spell-check"></div>
        {{ 'signature.initials' | translate }}
      </div>

      <div class="appearance__description" [class]="format === SignatureFormat.Draw ? 'pe-none' : ''">
        @if (format === SignatureFormat.Draw && isEmptyInitials() && !isLoading) {
          <span>{{ 'signature.drawInitialsHere' | translate }}</span>
        }

        @if (format === SignatureFormat.Image && !selectedInitialsImageUrl) {
          <label class="btn-S btn-text icon-start d-inline-block">
            <input type="file" class="d-none" accept="image/png,image/jpg,image/jpeg" (change)="selectInitialsImage($event.target['files'][0]); $any($event.target).value = ''" />
            <i class="far fa-cloud-upload-alt"></i>
            {{ 'signature.selectOrDrag' | translate }}
          </label>
        }
      </div>
    </div>
  </div>

  <form [formGroup]="signatureForm">
    <ng-container formGroupName="user">
      @if (currentUser) {
        <div class="form-fields__wrapper">
          <div class="form-fields__group">
            @if (format === SignatureFormat.Handwriting) {
              <label class="field__holder" [appFormControlWrap]="signatureForm.get('user.signature_text')" [class.d-none]="disableSignature">
                <input
                  type="text"
                  class="field"
                  formControlName="signature_text"
                  (keypress)="blockInvalidChars($event)"
                  (input)="emitSignatureText($event.target.value)"
                  required
                  appValidName
                  maxlength="20"
                />
                <span class="field__placeholder">{{ 'signature.signatureText' | translate }}</span>
              </label>
            }

            @if ([SignatureFormat.Handwriting, SignatureFormat.Eletronic].includes(format)) {
              <label class="field__holder field__holder--initials" [appFormControlWrap]="signatureForm.get('user.initials_text')" [class.d-none]="disableInitials">
                <input
                  type="text"
                  class="field"
                  formControlName="initials_text"
                  (keypress)="blockInvalidChars($event)"
                  (input)="emitInitialsText($event.target.value)"
                  required
                  maxlength="3"
                  appValidName
                />
                <span class="field__placeholder">{{ 'signature.initials' | translate }}</span>
              </label>
            }
          </div>

          @if (format === SignatureFormat.Handwriting) {
            <app-select
              class="field__holder field__holder--select"
              formControlName="font"
              [options]="fonts"
              [disableSearch]="true"
              (ngModelChange)="fontChange.emit($event)"
              placeholder="{{ 'settings.font' | translate }}"
              [class.d-none]="disableSignature"
            ></app-select>
          }
        </div>
      }
    </ng-container>
  </form>
</div>
